import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title: "How does ZTNA differ from traditional VPNs?",
    content: (
      <SimpleList
        points={[
          "ZTNA grants access to specific applications, not entire networks, reducing attack surfaces.",
          "VPN encrypts traffic but doesn’t verify user activity after login.",
          "ZTNA continuously authenticates and adapts security controls in real-time.",
        ]}
      />
    ),
  },
  {
    title: "What are the main security threats that ZTNA, VPN, and SASE protect against?",
    content: (
      <SimpleList
        points={[
          "Phishing & Credential Theft – Prevents attackers from using stolen credentials.",
          "Malware & Ransomware – Detects and blocks threats before they infect systems.",
          "Man-in-the-Middle (MITM) Attacks – VPN encryption ensures data integrity.",
          "DDoS Attacks – SASE traffic filtering mitigates volumetric cyberattacks.",
        ]}
      />
    ),
  },
  {
    title: "Can Secure Network Access improve cloud application performance?",
    content: (
      <SimpleList
        points={[
          "Yes! SASE combines SD-WAN and security, ensuring optimized cloud access without latency.",
          "ZTNA reduces bandwidth congestion by limiting access to necessary resources only.",
        ]}
      />
    ),
  },
  {
    title: "How does Edge Firewall enhance security?",
    content: (
      <SimpleList
        points={[
          "Inspects incoming/outgoing traffic to detect malware, botnets, and unauthorized access attempts.",
          "Blocks high-risk IP addresses and geolocation-based threats.",
          "Prevents lateral movement inside networks by segmenting data flows.",
        ]}
      />
    ),
  },
  {
    title: "How does SASE support remote work security?",
    content: (
      <SimpleList
        points={[
          "Applies zero-trust policies across all users, devices, and cloud applications.",
          "Provides encrypted remote access to corporate resources.",
          "Dynamically adjusts security policies based on user activity and risk levels.",
        ]}
      />
    ),
  },
  {
    title: "Can ZTNA and VPN be used together?",
    content: (
      <SimpleList
        points={[
          "Yes! ZTNA restricts access to applications, while VPN encrypts data traffic for additional security.",
          "Combining both enhances remote workforce security and prevents unauthorized lateral movement.",
        ]}
      />
    ),
  },
  {
    title: "What industries benefit most from Secure Network Access?",
    content: (
      <SimpleList
        points={[
          "Finance & Banking – Protects sensitive transactions and client data.",
          "Healthcare – Ensures .-compliant patient data protection.",
          "E-Commerce & Retail – Secures payment gateways and customer data.",
          "Government & Defense – Enforces zero-trust principles for classified networks.",
        ]}
      />
    ),
  },
  {
    title: "How does Zero Trust prevent insider threats?",
    content: (
      <SimpleList
        points={[
          "ZTNA applies least-privilege access, ensuring users only access what they need.",
          "Monitors user behavior in real time and flags abnormal activity.",
          "Reduces risk from compromised employee credentials.",
        ]}
      />
    ),
  },
  {
    title: "What compliance standards does Secure Network Access support?",
    content: (
      <SimpleList
        points={[
          "ISO 27001, GDPR, ., SOC 2, PCI-DSS, and NIST to meet regulatory security requirements.",
        ]}
      />
    ),
  },
  {
    title: "How does AI enhance VPN and firewall security?",
    content: (
      <SimpleList
        points={[
          "AI analyzes traffic patterns to detect suspicious activities.",
          "Automates security enforcement by blocking threats in real time.",
          "Reduces false positives, allowing IT teams to focus on real incidents.",
        ]}
      />
    ),
  },
  {
    title: "How does Secure Network Access prevent lateral movement in cyberattacks?",
    content: (
      <SimpleList
        points={[
          "ZTNA isolates compromised accounts, preventing access to other network areas.",
          "Firewall segmentation blocks unauthorized data flows.",
          "Behavior analytics detect abnormal user actions.",
        ]}
      />
    ),
  },
  {
    title: "Can OneMind’s Secure Network Access integrate with existing security tools?",
    content: (
      <SimpleList
        points={[
          "Yes! Integrates with SIEM, IAM, endpoint security, and cloud-native security platforms.",
          "Works with SD-WAN, VPN, and cloud security frameworks for full-stack protection.",
        ]}
      />
    ),
  },
];
